export const APP_LEGAL_DETAILS = {
  shortName: 'EJN',
  fullName: 'EJN Labs Ltd',
  beneficiaryName: 'EJN Labs Ltd',
  businessAddress: '44-45 Beaufort Court Admirals Way London E14 9XL',
  accountNumber: '24737863',
  companyNumber: '14198567',
  IBAN: 'GB55 TRWI 2308 0124 7378 63',
  jonpaul: {
    email: 'jonpaul.sargent@ejnlabs.com',
    firstName: 'Jonpaul',
    lastName: 'Sargent',
  },
};
